import React, { useState, useRef } from "react";

const ImageUploader = ({ onImageSelected, className }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Check if the file is an image
    if (!file.type.match("image.*")) {
      alert("Please select an image file");
      return;
    }

    // Create preview URL
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewUrl(reader.result);
    };
    reader.readAsDataURL(file);

    // Pass the file to parent component
    onImageSelected(file);
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  return (
    <div className={className}>
      <div className="flex flex-col items-center space-y-4">
        <input
          type="file"
          accept="image/*"
          className="hidden"
          ref={fileInputRef}
          onChange={handleFileChange}
        />

        {previewUrl ? (
          <div className="relative">
            <img
              src={previewUrl}
              alt="Uploaded preview"
              className="w-48 h-48 object-cover rounded-md"
            />
            <button
              onClick={triggerFileInput}
              className="absolute bottom-2 right-2 bg-[#23c55e] text-white p-2 rounded-full"
            >
              <span className="material-icons">edit</span>
            </button>
          </div>
        ) : (
          <button
            onClick={triggerFileInput}
            className="w-48 h-48 border-2 border-dashed border-[#23c55e] rounded-md flex flex-col items-center justify-center text-[#23c55e] hover:bg-[#23c55e10] transition-colors"
          >
            <span className="material-icons text-4xl mb-2">add_a_photo</span>
            <span>Upload Photo</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default ImageUploader;
